import styled from "styled-components";

export const ReportsPageContainer = styled.div`
    width: 100vw;
    height: 100vh;
    overflow-y: scroll;
    background: #FFF;
    .rotate{
        transform: rotate(180deg);
    }


    .anomalies-content{
        display: flex;
        flex-direction: column;
        gap: 20px;
    }
`;

export const ReportsPageHeader = styled.div`
    display: flex;
    width: 100%;
    margin-top: 6px;
    align-items: center;
    justify-content: center;
`;

export const TabSelect = styled.div`
    display: inline-flex;
    padding: 4px;
    justify-content: center;
    align-items: center;
    background-color: var(--grey-light-2-color);
    border-radius: 2px;
    gap: 2px;
`;

export const TabItem = styled.div`
    display: flex;
    width: 154px;
    padding: 8px 16px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    background-color: ${props=>props.active === "true" ? "var(--primary-color)" : "var(--grey-light-2-color)" };
    color: ${props=>props.active === "true" ? "var(--white-color)" : "var(--grey-medium-color)" } !important;
    border-radius: 2px;
    cursor: pointer;

    &:hover{
        background-color: var(--primary-color);
        color: var(--white-color) !important;
    }
`;


export const ExitContainer = styled.div`
    position: absolute;
    top: 22px;
    right: 32px;
    display: flex;
    gap: 8px;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background-color: var(--primary-color);
    color: var(--white-color) !important;
    padding: 8px 16px;
    border-radius: 2px;
`;